import React from "react";
import { Card, CardContent, CardMedia, Box, Typography } from "@mui/material";
import { useTranslation, Trans } from "react-i18next";

import { COLORS } from "constants/colors";
import { getRemainingTime } from "utils/time";

function ChiEpisodeStateCard({ userEpisode, soulName }) {
  const { t, i18n } = useTranslation(["chi"]);
  const { days, hours, minutes, isUnderOneHour, isExpired } = getRemainingTime(userEpisode.expire_at);
  return (
    <Card
      sx={{
        position: "relative",
        borderRadius: 2,
        boxShadow: 3,
        width: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        boxShadow: "0px 0px 4px rgba(200, 200, 200, 0.5)",
      }}
    >
      {/* アイキャッチ画像 */}
      <CardMedia
        component="img"
        sx={{
          width: "100%",
          maxHeight: 220,
          minHeight: 140,
          objectFit: "cover",
        }}
        image={userEpisode.eye_catch_url}
        alt={t("chi:episodeState.imageAlt", {
          defaultValue: userEpisode.name,
        })}
      />

      {/* <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: 2,
          flex: 1,
          backgroundColor: 'transparent',
        }}
      >
        <Typography variant="h6" sx={{ fontFamily: '"Noto Serif JP", serif', fontWeight: 700, fontSize: "18px", color: COLORS.TEXT_WHITE }}>
          {userEpisode.name}
        </Typography>

        <Typography variant="h4" sx={{ fontFamily: '"Noto Serif JP", serif', fontSize: "12px", fontWeight: "bold",  color: COLORS.TEXT_WHITE}}>
            残り交流日数{" "}
            <Typography component="span" sx={{ fontFamily: '"Noto Serif JP", serif',fontSize: "18px", fontWeight: "bold", color: COLORS.TEXT_WHITE }}>
              {userEpisode.remaining_days}
            </Typography>
            日
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontFamily: '"Noto Serif JP", serif',
            fontSize: "11px",
            fontWeight: "text.secondary",
            mt: 1,
            color: COLORS.TEXT_WHITE
          }}
        >
          {userEpisode.description}
        </Typography>
      </CardContent> */}

      <CardContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            ml: 3,
            mr: 3,
          }}
        >
          {/* キャラクター名 */}
          <Typography
            variant="h6"
            sx={{
              fontFamily: '"Noto Serif JP", serif',
              fontWeight: 700,
              fontSize: "18px",
              color: COLORS.TEXT_WHITE,
              mr: 2,
            }}
          >
            {userEpisode.name}
          </Typography>

          {/* 月額料金 */}
          <Box sx={{ mb: 1 }}>
            <Typography
              variant="h4"
              sx={{
                fontFamily: '"Noto Serif JP", serif',
                fontSize: "12px",
                fontWeight: "bold",
                color: COLORS.TEXT_WHITE,
              }}
            >
              {isExpired ? (
                <Trans
                  i18nKey="chi:remaining_expired"
                  components={{
                    strong: (
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: '"Noto Serif JP", serif',
                          fontSize: "18px",
                          fontWeight: "bold",
                          color: COLORS.TEXT_WHITE,
                          display: "inline",
                        }}
                      />
                    ),
                  }}
                />
              ) : isUnderOneHour ? (
                <Trans
                  i18nKey="chi:remaining_minutes"
                  values={{ minutes }}
                  components={{
                    strong: (
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: '"Noto Serif JP", serif',
                          fontSize: "18px",
                          fontWeight: "bold",
                          color: COLORS.TEXT_WHITE,
                          display: "inline",
                        }}
                      />
                    ),
                  }}
                />
              ) : (
                <Trans
                  i18nKey="chi:remaining_days"
                  values={{ days, hours }}
                  components={{
                    strong: (
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: '"Noto Serif JP", serif',
                          fontSize: "18px",
                          fontWeight: "bold",
                          color: COLORS.TEXT_WHITE,
                          display: "inline",
                        }}
                      />
                    ),
                  }}
                />
              )}
            </Typography>
          </Box>
        </Box>

        <Typography
          variant="body2"
          sx={{
            whiteSpace: "pre-line",
            fontSize: "15px",
            fontFamily: '"Noto Serif JP", serif',
            lineHeight: 1.6,
            color: COLORS.TEXT_WHITE,
            mt: 3,
            mb: 3,
            ml: 3,
            mr: 3,
          }} // 下のマージンを追加
        >
          {userEpisode.description}
          {"\n\n"}
          {t(`chi:relationship.${soulName}.${userEpisode.relationship_level}`)}
          {/* {relationship_phase_map[userEpisode.relationship_level]} */}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default ChiEpisodeStateCard;
